"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttons = exports.E_BUTTON_TYPE = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
const colors_1 = require("../basic/colors");
const cta_1 = require("./cta");
const spaces_1 = require("../basic/spaces");
const radii_1 = require("../basic/radii");
const media_1 = require("../basic/media");
const transition_1 = require("../basic/transition");
const fonts_1 = require("../basic/fonts");
var E_BUTTON_TYPE;
(function (E_BUTTON_TYPE) {
    E_BUTTON_TYPE["CLEAR_CTA"] = "clearCta";
    E_BUTTON_TYPE["PRIMARY"] = "primary";
    E_BUTTON_TYPE["SECONDARY"] = "secondary";
    E_BUTTON_TYPE["TEASER_LIGHT"] = "teaserLight";
    E_BUTTON_TYPE["TEASER_DARK"] = "teaserDark";
    E_BUTTON_TYPE["FLAT"] = "flat";
    E_BUTTON_TYPE["OUTLINED"] = "outlined";
    E_BUTTON_TYPE["ICON_BUTTON"] = "iconBtn";
    E_BUTTON_TYPE["LINK_BUTTON"] = "linkBtn";
    E_BUTTON_TYPE["CIRCLE_BUTTON"] = "circleBtn";
    E_BUTTON_TYPE["CIRCLE_BUTTON_PRIMARY"] = "circleBtnPrimary";
    E_BUTTON_TYPE["CIRCLE_BUTTON_SECONDARY"] = "circleBtnSecondary";
    E_BUTTON_TYPE["ACCORDION_BUTTON"] = "accordionBtn";
    E_BUTTON_TYPE["PRODUCT_CARD_BUTTON"] = "productCardBtn";
    E_BUTTON_TYPE["APPLY_BUTTON"] = "applyButton";
    E_BUTTON_TYPE["BURGER_BUTTON"] = "burgerButton";
    E_BUTTON_TYPE["SWITCH_BUTTON"] = "switchButton";
    E_BUTTON_TYPE["HEADER_BUTTON"] = "headerBtn";
})(E_BUTTON_TYPE || (exports.E_BUTTON_TYPE = E_BUTTON_TYPE = {}));
exports.buttons = (0, basic_1.applyBase)({
    [E_BUTTON_TYPE.CLEAR_CTA]: cta_1.clearCta,
    [E_BUTTON_TYPE.PRIMARY]: Object.assign(Object.assign({}, cta_1.ctaStyles), { borderRadius: '6px', paddingTop: '8px', paddingBottom: '8px', border: '2px solid', borderColor: colors_1.colors.primary, backgroundColor: colors_1.colors.primary, ':focus:not([disabled]),:hover:not([disabled]),:focus-visible:not([disabled])': {
            backgroundColor: colors_1.colors.interactionPrimary,
            borderColor: colors_1.colors.interactionPrimary,
        } }),
    [E_BUTTON_TYPE.SECONDARY]: Object.assign(Object.assign({}, cta_1.ctaStyles), { borderRadius: '6px', paddingTop: '8px', paddingBottom: '8px', border: '2px solid', borderColor: colors_1.colors.primary, color: colors_1.colors.primary, backgroundColor: 'transparent', ':hover:not([disabled]),:focus:not([disabled]),:focus-visible:not([disabled])': {
            borderColor: colors_1.colors.interactionPrimary,
            backgroundColor: colors_1.colors.lightMint,
            color: colors_1.colors.interactionPrimary,
        } }),
    [E_BUTTON_TYPE.TEASER_LIGHT]: Object.assign(Object.assign({}, cta_1.ctaStyles), { borderRadius: '6px', paddingTop: '8px', paddingBottom: '8px', border: '2px solid', borderColor: 'rgba(0, 0, 0, 0.40)', color: colors_1.baseColors.black, backgroundColor: 'transparent', ':hover:not([disabled]),:focus:not([disabled]),:focus-visible:not([disabled])': {
            borderColor: colors_1.baseColors.black,
            color: colors_1.baseColors.black,
        } }),
    [E_BUTTON_TYPE.TEASER_DARK]: Object.assign(Object.assign({}, cta_1.ctaStyles), { borderRadius: '6px', paddingTop: '8px', paddingBottom: '8px', border: '2px solid', borderColor: 'rgba(255, 255, 255, 0.70)', color: colors_1.baseColors.white, backgroundColor: 'transparent', ':hover:not([disabled]),:focus:not([disabled]),:focus-visible:not([disabled])': {
            borderColor: colors_1.baseColors.white,
            color: colors_1.baseColors.white,
        } }),
    [E_BUTTON_TYPE.FLAT]: {
        color: colors_1.colors.secondary,
        background: colors_1.baseColors.white,
        border: '1px solid',
        borderColor: colors_1.colors.borderColor,
        borderRadius: 0,
        transition: transition_1.transition.slow,
        '&:hover,:focus,:active': {
            background: colors_1.baseColors.gray[3],
        },
    },
    [E_BUTTON_TYPE.OUTLINED]: {
        borderRadius: radii_1.radii.default,
        color: colors_1.baseColors.black,
        fontSize: fonts_1.fontSizes[3],
        border: '1px solid',
        borderColor: colors_1.colors.borderColor,
        paddingTop: spaces_1.space[2],
        paddingBottom: spaces_1.space[2],
        paddingRight: spaces_1.space[3],
        paddingLeft: spaces_1.space[3],
    },
    [E_BUTTON_TYPE.ICON_BUTTON]: Object.assign(Object.assign({}, cta_1.clearCta), { backgroundColor: 'transparent', padding: spaces_1.space[1], fontSize: '0px', color: 'inherit', letterSpacing: 'initial', lineHeight: 1.3, svg: {
            margin: 0,
        }, '&:focus-visible': {
            outlineOffset: '-2px',
            outline: 'auto 1px',
            outlineColor: colors_1.baseColors.black,
        } }),
    [E_BUTTON_TYPE.LINK_BUTTON]: Object.assign(Object.assign({}, cta_1.ctaStyles), { ':hover:not([disabled]),:focus:not([disabled]),:focus-visible:not([disabled])': {
            background: 'transparent',
            color: colors_1.colors.defaultText,
            textDecorationColor: colors_1.colors.defaultText,
            transform: 'scale(1)',
        }, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: spaces_1.space[2], paddingBottom: spaces_1.space[2], paddingLeft: 0, paddingRight: 0, color: colors_1.colors.defaultText, border: '2px solid transparent', borderRadius: '6px', background: 'transparent', transition: 'none', textDecoration: 'underline', textDecorationColor: colors_1.colors.linkUnderlineColor, textUnderlineOffset: '6px' }),
    [E_BUTTON_TYPE.CIRCLE_BUTTON]: {
        borderRadius: '50%',
        fontSize: '0px',
        display: 'flex',
        padding: 0,
        justifyContent: 'center',
        alignItems: 'center',
        letterSpacing: 0,
    },
    [E_BUTTON_TYPE.CIRCLE_BUTTON_PRIMARY]: {
        backgroundColor: colors_1.colors.primary,
        borderRadius: '50%',
        fontSize: '0px',
        display: 'flex',
        padding: 0,
        justifyContent: 'center',
        alignItems: 'center',
        letterSpacing: 0,
        width: '48px',
        height: '48px',
        '.icon': {
            color: colors_1.baseColors.white,
            margin: 0,
        },
        ':hover:not([disabled]),:focus:not([disabled]),:focus-visible:not([disabled])': {
            backgroundColor: colors_1.colors.interactionPrimary,
            textDecoration: 'underline',
            outline: 'none',
        },
        '&:disabled, &[disabled]': {
            backgroundColor: colors_1.colors.lightGreyFirst,
            borderColor: colors_1.colors.lightGreyFirst,
            '.icon': {
                color: colors_1.colors.secondary,
            },
            color: colors_1.colors.secondary,
            cursor: 'default',
            textDecoration: 'none',
        },
    },
    [E_BUTTON_TYPE.CIRCLE_BUTTON_SECONDARY]: {
        backgroundColor: colors_1.baseColors.white,
        borderRadius: '50%',
        fontSize: '0px',
        display: 'flex',
        padding: 0,
        justifyContent: 'center',
        alignItems: 'center',
        letterSpacing: 0,
        width: '48px',
        height: '48px',
        border: '2px solid',
        borderColor: colors_1.colors.primary,
        '.icon': {
            color: colors_1.colors.primary,
            margin: 0,
        },
        ':hover:not([disabled]),:focus:not([disabled]),:focus-visible:not([disabled])': {
            backgroundColor: colors_1.colors.lightMint,
            border: '2px solid',
            borderColor: colors_1.colors.interactionPrimary,
            textDecoration: 'underline',
            '.icon': {
                color: colors_1.colors.interactionPrimary,
            },
            outline: 'none',
        },
        '&:disabled, &[disabled]': {
            backgroundColor: colors_1.colors.lightGreyFirst,
            borderColor: colors_1.colors.lightGreyFirst,
            '.icon': {
                color: colors_1.colors.secondary,
            },
            color: colors_1.colors.secondary,
            cursor: 'default',
            textDecoration: 'none',
        },
    },
    [E_BUTTON_TYPE.ACCORDION_BUTTON]: Object.assign(Object.assign({ textAlign: 'left', background: colors_1.baseColors.white, color: colors_1.baseColors.black, display: 'flex', alignItems: 'center', justifyContent: 'space-between', borderRadius: 0, borderBottom: '1px solid', borderColor: colors_1.colors.lightGreyFirst, width: '100%', padding: `${spaces_1.space[3]} ${spaces_1.space[0]}` }, font_faces_1.FONT_SIZE.XS), { fontWeight: font_faces_1.E_FONT_WEIGHT.REGULAR }),
    [E_BUTTON_TYPE.PRODUCT_CARD_BUTTON]: Object.assign(Object.assign({}, cta_1.ctaStyles), { borderRadius: '0px 0px 3px 0px', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '22px', height: '38px', padding: 0, [media_1.media.tablet]: {
            width: '26px',
            height: '42px',
        }, svg: {
            height: '12px',
        } }),
    [E_BUTTON_TYPE.APPLY_BUTTON]: Object.assign(Object.assign({}, cta_1.ctaStyles), { width: '100%', borderRadius: '0px' }),
    [E_BUTTON_TYPE.BURGER_BUTTON]: {
        width: '30px',
        height: '30px',
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: spaces_1.space[1],
        paddingLeft: spaces_1.space[1],
        color: colors_1.baseColors.black,
        fontSize: 0,
    },
    [E_BUTTON_TYPE.SWITCH_BUTTON]: {
        wrapper: {
            display: 'flex',
            border: '1px solid',
            borderColor: 'borderColor',
            borderRadius: '30px',
            color: 'secondary',
            width: '214px',
            'input + label': {
                border: '1px solid',
                borderColor: 'white',
                borderRadius: '30px',
            },
            '&:has(:focus-visible)': {
                outline: `auto 1px`,
                outlineOffset: '1px',
                outlineColor: colors_1.baseColors.black,
            },
            'input:focus:not(:focus-visible)': {
                outline: 0,
            },
            'input:checked + label': {
                border: '1px solid',
                borderColor: 'primary',
                backgroundColor: 'white',
                color: 'primary',
                borderRadius: '30px',
            },
        },
        label: {
            flexBasis: '50%',
            textAlign: 'center',
            py: 2,
            px: 4,
            cursor: 'pointer',
        },
    },
    [E_BUTTON_TYPE.HEADER_BUTTON]: Object.assign(Object.assign({}, cta_1.ctaStyles), { marginRight: spaces_1.space[2], paddingLeft: spaces_1.space[3], paddingRight: spaces_1.space[3], fontSize: fonts_1.fontSizes[1], '.icon': { display: 'none' } }),
});
//# sourceMappingURL=buttons.js.map